import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStarship, faSatellite, faStarfighter, faDrone } from "@fortawesome/pro-light-svg-icons";

function ShipType({ ship, size }) {
  return (
    <>
      {ship && ship.frame.symbol == 'FRAME_FRIGATE' && <FontAwesomeIcon icon={faStarship} size={size} />}
      {ship && ship.frame.symbol == 'FRAME_PROBE' && <FontAwesomeIcon icon={faSatellite} size={size} />}
      {ship && ship.frame.symbol == 'FRAME_FIGHTER' && <FontAwesomeIcon icon={faStarfighter} size={size} />}
      {ship && ship.frame.symbol == 'FRAME_DRONE' && <FontAwesomeIcon icon={faDrone} size={size} />}
      {ship && ship.frame.symbol == 'FRAME_MINER' && <FontAwesomeIcon icon={faStarship} size={size} />}
    </>
  );
}

export default ShipType;